// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 32 32%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255,255,255, 1%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 8h24M4 16h24M4 24h24%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../Assets/Images/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
    width: 8px;
    /* Optional: just make scrollbar invisible */
}

::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background-color: #d3d3d3;
    height: 80px;
}

.logout {
    cursor: pointer;
}

.navbar-toggler:focus,
.btn-close:focus {
    box-shadow: none !important;
}

.navbar-toggler {
    border: none !important;
}

.avatar-dropdown {
    background-color: #202225;
    width: 220px;
    right: 10px;
    padding: 20px;
    color: #fff;
    position: fixed;
    top: 50px;
    border-radius: 4px;
    z-index: 9999;
}

.avatar-dropdown h4 {
    font-size: 1rem;
    text-align: left;
}

.avatar-dropdown :hover {
    cursor: pointer;
}

.offcanvas-start {
    background-color: #202225 !important;
    width: 260px;
}

.navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.btn-close {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
    background-size: 25px 50px !important;
    opacity: 0.9 !important;
}

.modal-logo {
    width: 65%;
}

.sidebarItems {
    text-decoration: none;
    color: white;
}

.sidebarItems:hover {
    color: white;
}

.dropdownList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: white;
}

.dropdownList-items {
    text-decoration: none;
    color: white;
    margin-left: 22px;
}
.navbar__link--active{
    color: #ff2120;
}
.dropdownList-items:hover {
    color: white;
}

.user-btn {
    background-color: #ff2120 !important;
    border: none !important;
    height: 40px !important;
    /* width: 60px; */
    font-size: 18px !important;
    font-weight: 500 !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/MainSidebar/sidebar.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,WAAW;IACX,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,oEAAkR;AACtR;;AAEA;IACI,oEAAoE;IACpE,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,0BAA0B;IAC1B,2BAA2B;AAC/B","sourcesContent":["::-webkit-scrollbar {\n    width: 8px;\n    /* Optional: just make scrollbar invisible */\n}\n\n::-webkit-scrollbar-thumb {\n    border-radius: 1px;\n    background-color: #d3d3d3;\n    height: 80px;\n}\n\n.logout {\n    cursor: pointer;\n}\n\n.navbar-toggler:focus,\n.btn-close:focus {\n    box-shadow: none !important;\n}\n\n.navbar-toggler {\n    border: none !important;\n}\n\n.avatar-dropdown {\n    background-color: #202225;\n    width: 220px;\n    right: 10px;\n    padding: 20px;\n    color: #fff;\n    position: fixed;\n    top: 50px;\n    border-radius: 4px;\n    z-index: 9999;\n}\n\n.avatar-dropdown h4 {\n    font-size: 1rem;\n    text-align: left;\n}\n\n.avatar-dropdown :hover {\n    cursor: pointer;\n}\n\n.offcanvas-start {\n    background-color: #202225 !important;\n    width: 260px;\n}\n\n.navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E\") !important;\n}\n\n.btn-close {\n    background-image: url(\"../../../Assets/Images/close.svg\") !important;\n    background-size: 25px 50px !important;\n    opacity: 0.9 !important;\n}\n\n.modal-logo {\n    width: 65%;\n}\n\n.sidebarItems {\n    text-decoration: none;\n    color: white;\n}\n\n.sidebarItems:hover {\n    color: white;\n}\n\n.dropdownList {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    color: white;\n}\n\n.dropdownList-items {\n    text-decoration: none;\n    color: white;\n    margin-left: 22px;\n}\n.navbar__link--active{\n    color: #ff2120;\n}\n.dropdownList-items:hover {\n    color: white;\n}\n\n.user-btn {\n    background-color: #ff2120 !important;\n    border: none !important;\n    height: 40px !important;\n    /* width: 60px; */\n    font-size: 18px !important;\n    font-weight: 500 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
